import { useState } from "react"
import Card, { CardBody, CardHeader, CardTitle } from "../../../../bootstrap/Card"
import Button from "../../../../bootstrap/Button"
import Checks from "../../../../bootstrap/forms/Checks"
import Alert from "../../../../bootstrap/Alert"
import Money from "../../../../../helpers/utils/money/money"

const ModifiersConfigStep = ({ 
    availableCategories, 
    selectedModifiers, 
    onModifierToggle, 
    onSelectAll, 
    onClear 
}) => {
    const [expandedCategories, setExpandedCategories] = useState({})

    const toggleExpansion = (categoryId) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }))
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>Configuração de Complementos</CardTitle>
            </CardHeader>
            <CardBody>
                {availableCategories.length === 0 ? (
                    <Alert color="info" isLight>
                        Produtos selecionados não possuem complementos configurados.
                    </Alert>
                ) : (
                    <>
                        <div className="d-flex gap-2 mb-4">
                            <Button color="dark" size="sm" isLight onClick={onSelectAll}>
                                Selecionar Todos
                            </Button>
                            <Button color="dark" size="sm" isLight onClick={onClear}>
                                Limpar
                            </Button>
                        </div>
                        {availableCategories.map(cat => {
                            const isSelected = selectedModifiers.some(m => m.app_modifier_group_id === cat.id)
                            const isExpanded = expandedCategories[cat.id]
                            return (
                                <Card key={cat.id} className={`mb-3 ${isSelected ? 'border-dark bg-light' : ''}`}>
                                    <CardBody>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div 
                                                onClick={() => onModifierToggle(cat)}
                                                style={{ cursor: 'pointer' }}
                                                className="flex-grow-1"
                                            >
                                                <Checks 
                                                    type="checkbox" 
                                                    checked={isSelected} 
                                                    readOnly 
                                                    className="me-2" 
                                                />
                                                <strong>{cat.name}</strong>
                                                <span className="badge bg-dark ms-2">
                                                    {cat.complements.length} itens
                                                </span>
                                            </div>
                                            {isSelected && (
                                                <Button
                                                    color="link"
                                                    size="sm"
                                                    className="p-1 text-dark"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        toggleExpansion(cat.id)
                                                    }}
                                                >
                                                    {isExpanded ? '▲' : '▼'}
                                                </Button>
                                            )}
                                        </div>
                                        {isSelected && isExpanded && (
                                            <div className="mt-3 ps-4">
                                                <div className="border-start border-2 border-dark ps-3">
                                                    {cat.complements.map(comp => (
                                                        <div key={comp.id} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                                            <div>
                                                                <strong>{comp.name}</strong>
                                                                {comp.description && (
                                                                    <small className="text-muted d-block">{comp.description}</small>
                                                                )}
                                                            </div>
                                                            <span className="text-muted">
                                                                {Money.centsToMaskMoney(comp.price || 0)}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            )
                        })}
                    </>
                )}
            </CardBody>
        </Card>
    )
}

export default ModifiersConfigStep
